// @core/api/endpoints/userprofile/activate_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateAvatarRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Set avatar as active
 * Sets the specified avatar as the active profile picture. The previously active avatar becomes inactive but is not deleted.
 */
export async function ActivateAvatar(
  profile_id: string,
  avatar_id: string,
  data: ActivateAvatarRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/avatars/:avatar_id/activate`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
